// extracted by mini-css-extract-plugin
export default {"root":"FW39k2F18aherNLqOaVm","img":"j4E52bT3FIvxfV3vmkuX","name":"cgpEN9lw693ONMaOxUyi","age":"iQZpQ1slX8U8VFFB0jEv"};